/** Shared UI strings used across multiple pages. EN mirrors SV until translated. */
export const siteCommonSv = {
    loading: {
        issues: 'Laddar emissionsdata...',
        calendar: 'Laddar kalenderdata...',
        companies: 'Laddar bolagsdata...',
        warrants: 'Laddar teckningsoptionsdata...',
        convertibles: 'Laddar konvertibeldata...',
    },
    errors: {
        unexpected: 'Ett oväntat fel inträffade.',
    },
    actions: {
        showMore: 'Visa mer',
        showLess: 'Visa mindre',
        showAll: 'Visa alla',
        showTable: 'Visa tabell',
        hideTable: 'Dölj tabell',
        showDetailed: 'Visa detaljerat',
        hideDetailed: 'Dölj detaljerat',
        showAdvancedFilters: 'Visa avancerade filter',
        hideAdvancedFilters: 'Dölj avancerade filter',
        edit: 'Redigera',
        delete: 'Ta bort',
        cancel: 'Avbryt',
        save: 'Spara',
        showCompletedConvertibles: 'Visa avslutade konvertibellån',
    },
    filters: {
        allOf: 'Alla {{label}}',
        selectionOf: 'Urval av {{label}}',
        showAll: 'Visa samtliga',
        showAllOptions: 'Visa alla optioner',
        onlyListedOptions: 'Visa enbart noterade optioner',
        onlyUnlistedOptions: 'Visa enbart onoterade optioner',
        onlyCompletedIssues: 'Visa enbart genomförda emissioner',
        hideCompletedIssues: 'Dölj genomförda emissioner',
        allCompanies: 'Alla bolag',
        allIssues: 'Alla emissioner',
        industry: 'Bransch',
        industries: 'Branscher',
        lists: 'Listor',
        watchListOnly: 'Visa enbart bevakade',
        watchListOnlyAria: 'Visa enbart favoritmarkerad',
        min: 'Min',
        max: 'Max',
        minimumDistanceAria: 'Minimum distance',
    },
    notCommunicatedYet: 'Inte kommunicerat ännu',
    notAvailable: 'N/A',
    missing: 'Saknas',
    pagination: {
        previous: 'Föregående',
        next: 'Nästa',
        later: 'Senare',
    },
    pricing: {
        vwapDiscount: 'VWAP-rabatt:',
        min: 'Min:',
        max: 'Max:',
        parValue: 'Kvotvärde',
        fixedPrice: 'Fast kurs',
        perShare: 'per aktie',
        days: 'dagar',
        day: 'dag',
    },
    weekdays: {
        sun: 'sön',
        mon: 'mån',
        tue: 'tis',
        wed: 'ons',
        thu: 'tor',
        fri: 'fre',
        sat: 'lör',
    },
    dates: {
        today: 'Idag',
        periodStart: 'Tidsperiod start',
        periodEnd: 'Tidsperiod slut',
        start: 'Startdatum',
        end: 'Slutdatum',
    },
    table: {
        total: 'Summa',
        count: 'Antal',
        name: 'Namn',
        amount: 'Belopp',
        share: 'Aktie',
        type: 'Typ',
        date: 'Datum',
        percent: 'Procent',
        min: 'Min',
        max: 'Max',
        average: 'Medel',
    },
    admin: {
        editLink: '[Redigera]',
        viewAdminPr: '[Visa admin pm]',
    },
    footer: {
        termsOfUse: 'Användarvillkor',
        privacyPolicy: 'Integritetspolicy',
    },
}
